<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatUpper('nome')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Turno" prop="turno" :rules="[$requiredChange]" key="turno">
              <el-select v-model="dados.turno">
                <el-option label="MANHÃ" value="manha"></el-option>
                <el-option label="TARDE" value="tarde"></el-option>
                <el-option label="NOITE" value="noite"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Destino" prop="destino" key="destino">
              <el-input v-model="dados.destino" maxlength="191" v-on:blur="formatUpper('destino')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Horário de saída" prop="horario_saida" key="horario_saida">
              <el-time-select v-model="dados.horario_saida" :picker-options="{ start: '00:00', step: '00:05', end: '23:55' }" placeholder="--:--" clearable style="width:100%"></el-time-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Horário de chegada" prop="horario_chegada" key="horario_chegada">
              <el-time-select v-model="dados.horario_chegada" :picker-options="{ start: '00:00', step: '00:05', end: '23:55' }" placeholder="--:--" clearable style="width:100%"></el-time-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Motorista" prop="motorista_id" key="motorista_id">
              <el-select v-model="dados.motorista_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getMotoristaByFilter" :loading="loadingMotorista">
                <el-option v-for="m in motoristas" :key="m.id" :label="m.nome" :value="m.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Veículo" prop="veiculo_id" key="veiculo_id">
              <el-select v-model="dados.veiculo_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getVeiculoByFilter" :loading="loadingVeiculo">
                <el-option v-for="v in veiculos" :key="v.id" :label="v.placa" :value="v.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Monitor" prop="monitor_id" key="monitor_id">
              <el-select v-model="dados.monitor_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getMonitorByFilter" :loading="loadingMonitor">
                <el-option v-for="m in monitores" :key="m.id" :label="m.nome" :value="m.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Quilometragem estimada" prop="quilometragem_estimada" key="quilometragem_estimada">
              <el-input v-model="dados.quilometragem_estimada" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Tempo estimado (min)" prop="tempo_estimado" key="tempo_estimado">
              <el-input v-model="dados.tempo_estimado" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Status" prop="status" :rules="[$requiredChange]" key="status">
              <el-select v-model="dados.status">
                <el-option label="ATIVA" value="ativa"></el-option>
                <el-option label="INATIVA" value="inativa"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="3" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-rota" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    loadingMotorista: false,
    motoristas: [],
    loadingVeiculo: false,
    veiculos: [],
    loadingMonitor: false,
    monitores: [],
    dados: {
      id: '',
      instituicao_id: '',
      nome: '',
      descricao: '',
      destino: '',
      horario_saida: '',
      horario_chegada: '',
      turno: 'manha',
      motorista_id: '',
      veiculo_id: '',
      monitor_id: '',
      quilometragem_estimada: '',
      tempo_estimado: '',
      status: 'ativa'
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/getById/` + id, this.$store.getters.getHeaderAuth)
      const data = JSON.parse(JSON.stringify(res.data))

      // pré-popular selects remotos
      if (data.motorista) { this.motoristas = [{ id: data.motorista.id, nome: data.motorista.nome }]; delete data.motorista }
      if (data.veiculo) { this.veiculos = [{ id: data.veiculo.id, placa: data.veiculo.placa }]; delete data.veiculo }
      if (data.monitor) { this.monitores = [{ id: data.monitor.id, nome: data.monitor.nome }]; delete data.monitor }

      // horário vem do banco como HH:mm:ss; el-time-select espera HH:mm
      if (data.horario_saida) data.horario_saida = String(data.horario_saida).substring(0, 5)
      if (data.horario_chegada) data.horario_chegada = String(data.horario_chegada).substring(0, 5)

      this.dados = data
    },
    getMotoristaByFilter (query) {
      if (!query || query.length < 2) { this.motoristas = []; return }
      this.loadingMotorista = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/motorista/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.motoristas = JSON.parse(JSON.stringify(res.data)); this.loadingMotorista = false })
        .catch(e => { this.loadingMotorista = false; this.$store.commit('throwException', e) })
    },
    getVeiculoByFilter (query) {
      if (!query || query.length < 2) { this.veiculos = []; return }
      this.loadingVeiculo = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/searchByPlaca`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.veiculos = JSON.parse(JSON.stringify(res.data)); this.loadingVeiculo = false })
        .catch(e => { this.loadingVeiculo = false; this.$store.commit('throwException', e) })
    },
    getMonitorByFilter (query) {
      if (!query || query.length < 2) { this.monitores = []; return }
      this.loadingMonitor = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/monitor/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.monitores = JSON.parse(JSON.stringify(res.data)); this.loadingMonitor = false })
        .catch(e => { this.loadingMonitor = false; this.$store.commit('throwException', e) })
    },
    onSubmit () {
      document.getElementById("btn-rota").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitRota')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

